import useTheme from "@/hooks/useTheme";

const FilmIcon = () => {
    const {theme} = useTheme()
    return <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
        width="24px" height="24px" viewBox="0 0 512.000000 512.000000"
        preserveAspectRatio="xMidYMid meet">

        <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
            fill={theme==="dark"? "#ffffff":"#000000"} stroke="none">
            <path d="M3820 5105 c-30 -7 -748 -214 -1595 -459 -1086 -315 -1561 -457
-1612 -482 -192 -93 -318 -319 -300 -533 3 -39 42 -190 94 -366 l88 -300 5
-1260 c6 -1379 1 -1281 68 -1410 75 -143 233 -258 389 -284 47 -8 262 -11 705
-9 l638 3 26 27 c37 37 37 99 0 136 l-26 27 -663 5 c-705 6 -686 4 -767 55
-75 48 -128 118 -154 205 -14 47 -16 144 -16 757 l0 703 1958 -2 1957 -3 3
-665 c1 -373 -2 -695 -7 -733 -18 -127 -86 -224 -199 -279 l-67 -33 -660 -5
c-363 -3 -668 -9 -677 -13 -27 -14 -48 -53 -48 -90 0 -39 34 -83 72 -92 12 -3
320 -4 683 -3 656 3 660 3 719 26 83 31 142 68 205 126 69 65 114 135 148 233
l28 78 0 1263 0 1264 -33 29 -32 29 -1717 0 c-944 0 -1714 2 -1712 5 3 2 743
218 1645 479 1788 518 1684 484 1684 559 0 53 -176 645 -215 724 -107 217
-381 345 -615 288z m267 -219 c67 -30 140 -98 172 -161 17 -34 153 -482 163
-539 3 -17 -20 -26 -195 -78 l-199 -57 -136 132 c-75 74 -237 230 -360 347
-122 118 -219 217 -215 220 7 6 438 132 548 161 57 15 157 4 222 -25z m-646
-546 c194 -186 355 -343 357 -348 1 -4 -116 -42 -260 -84 l-263 -75 -130 127
c-71 69 -232 225 -357 345 -126 120 -228 221 -228 224 0 7 485 149 511 150 9
1 175 -152 370 -339z m-693 -275 c166 -159 298 -292 294 -296 -8 -8 -494 -149
-512 -149 -6 0 -173 156 -371 347 l-360 347 263 76 263 76 61 -55 c33 -31 196
-186 362 -346z m-808 -165 c228 -218 355 -347 347 -351 -6 -4 -125 -39 -264
-79 l-252 -73 -361 349 c-219 210 -357 350 -349 353 56 19 506 149 511 147 4
0 170 -156 368 -346z m-751 -220 c198 -189 359 -345 358 -347 -11 -10 -872
-251 -878 -246 -4 5 -40 121 -80 258 -64 218 -73 260 -73 330 0 65 5 90 25
135 28 61 74 118 122 152 36 26 137 69 154 65 7 -1 174 -157 372 -347z m381
-837 c0 -3 -93 -167 -207 -365 l-207 -358 -228 0 -228 0 0 365 0 365 435 0
c239 0 435 -3 435 -7z m787 0 c-3 -5 -96 -165 -207 -358 -111 -192 -205 -353
-209 -358 -4 -4 -130 -6 -279 -5 l-272 3 196 340 c108 187 202 350 210 363 14
22 15 22 290 22 151 0 273 -3 271 -7z m781 -2 c-1 -4 -95 -169 -208 -364
l-205 -356 -279 -1 -278 0 14 23 c8 12 104 176 212 365 l198 342 275 0 c151 0
273 -4 271 -9z m580 -356 l-211 -365 -274 0 c-172 0 -273 4 -271 10 2 5 95
169 208 364 l205 356 277 0 276 0 -210 -365z m902 0 l0 -365 -441 0 c-242 0
-438 3 -436 8 23 41 393 683 403 700 14 22 17 22 244 22 l230 0 0 -365z"/>
            <path d="M2330 1662 c-19 -9 -40 -28 -47 -42 -10 -19 -13 -152 -13 -557 l0
-533 29 -32 c55 -62 53 -63 564 232 342 198 462 272 473 292 21 41 17 74 -13
107 -29 32 -891 533 -934 544 -15 4 -39 0 -59 -11z m493 -462 c119 -69 216
-128 214 -132 -2 -7 -553 -328 -562 -328 -3 0 -5 149 -5 331 l0 331 68 -39
c38 -21 166 -94 285 -163z"/>
            <path d="M2615 189 c-98 -57 -50 -205 59 -185 108 20 104 176 -5 192 -18 2
-43 -1 -54 -7z"/>
        </g>
    </svg>

};

export default FilmIcon;